import StaticStickitView from '../static_stickit_view';

export default StaticStickitView.extend({
  // A view for selecting the search type (homes / sitters)
  // This view takes a Query as its model, and the radio buttons are bound
  // its 'service_type' attribute.

  bindings: {
    '.js-search-type-btn': 'service_type',
    '.js-search-type-dropdown': 'service_type',
  },

  events: {
    'click .js-search-type-btn': 'onSearchTypeBtnClicked',
  },

  onSearchTypeBtnClicked(event) {
    const self = this;

    setTimeout(() => {
      const serviceType = self.model.get('service_type');
      self.$('.js-search-type-btn').removeClass('active');
      self
        .$('.js-search-type-btn')
        .filter(`[data-value="${serviceType}"]`)
        .addClass('active');
    }, 0);

    event.preventDefault();
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/search_type_view.js